import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import HeaderCell from '~/glm/components/guest-list/header/header-cell.jsx';
import SortableHeaderCell from '~/glm/components/guest-list/sortable-header-cell';
import Checkbox from '~/glm/components/guest-list/checkbox';
import classNames from 'classnames';
import cellStyles from './guest-row.scss';
import headerStyles from './header-cell.scss';
import rowStyles from './row.scss';
import { Tooltip, TooltipContainer } from '@xo-union/tk-component-tooltips';
import Icon from '@xo-union/tk-component-icons';

const sortbyHousehold = sort => !sort.direction || sort.attribute === 'partyOf';
const householdGrouping = ({ filter, rsvpFilter, mealFilter, sort }) =>
  !filter && !rsvpFilter && !mealFilter && sortbyHousehold(sort);

const ContactTitleCell = () => {
  return (
    <HeaderCell name="Contact" className={classNames(cellStyles.contactInfo, 'text-center')}>
      <div className={headerStyles.tooltipContainer}>
        <TooltipContainer>
          <div data-testid="header-contact-tip" className={headerStyles.informationIcon}>
            <Icon name="info" size="sm" />
          </div>
          <Tooltip data-testid="header-contact-tooltip" arrowPosition="top" className={headerStyles.tooltip}>
            Send each guest on your list the link to their own unique address collection form to add or update their
            info.
          </Tooltip>
        </TooltipContainer>
      </div>
    </HeaderCell>
  );
};

@observer
class SingleEventListColumns extends React.Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    rsvpEnabled: PropTypes.bool,
    hasWWS: PropTypes.bool,
    numberOfHouseholds: PropTypes.number,
    trackSelectAllGuests: PropTypes.func,
    usesQuestions: PropTypes.bool.isRequired,
  };

  handleSelectionCellClick = () => {
    const { gdsUiState, trackSelectAllGuests } = this.props;
    const promises = [gdsUiState.toggleAllGuestsSelection()];
    if (!gdsUiState.allGuestsSelected) {
      promises.push(trackSelectAllGuests());
    }
    return Promise.all(promises);
  };

  renderHeaderSelectionCell = () => {
    const { gdsUiState } = this.props;
    return (
      <HeaderCell className={classNames(headerStyles.selectionCell)}>
        <Checkbox id="selectAllGuests" checked={gdsUiState.allGuestsSelected} onClick={this.handleSelectionCellClick} />
      </HeaderCell>
    );
  };

  render() {
    const { gdsUiState, numberOfHouseholds, usesQuestions, rsvpEnabled, hasWWS } = this.props;

    return (
      <>
        <tr className={rowStyles.headerRow}>
          {this.renderHeaderSelectionCell()}
          <SortableHeaderCell
            entity="guest"
            sortAttr="lastName"
            name="Name"
            className={cellStyles.name}
            numberOfHouseholds={numberOfHouseholds}
          />
          {householdGrouping(gdsUiState) && (
            <SortableHeaderCell
              entity="guest"
              sortAttr="partyOf"
              name="Party Of"
              className={cellStyles.partyOf}
              numberOfHouseholds={numberOfHouseholds}
            />
          )}
          <ContactTitleCell />
          <HeaderCell name="RSVP Status" className={classNames(cellStyles.rsvp)} id="glm-first-visit-1" />
          {!usesQuestions && gdsUiState.selectedEvent && gdsUiState.selectedEvent.hasMeals() && (
            <HeaderCell data-testid="meal-choice-column" name="Meal Choice" className={classNames(cellStyles.meal)} />
          )}
          <HeaderCell name="My Notes" className={classNames(cellStyles.notes)} />
          <HeaderCell name="Gift" className={classNames(cellStyles.gift)} />
          <HeaderCell name="Thank You" className={classNames(cellStyles.thankYou)} />
          {usesQuestions && rsvpEnabled && hasWWS && (
            <HeaderCell name="" className={classNames(cellStyles.rsvpDetail)} />
          )}
        </tr>
      </>
    );
  }
}

export default SingleEventListColumns;
